import {Box, Card, Grid} from '@primer/react-brand/esm'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import {clsx} from 'clsx'
import type {IconLinkItem} from '../../types'
import {renderWithoutParagraphs} from '../../utils'
import baseStyles from '../../styles/base.module.css'

export type FlexSuiteIntroIconCardsProps = {
  cards?: IconLinkItem[]
  promoteFirstHeading?: boolean
}

export function FlexSuiteIntroIconCards({cards, promoteFirstHeading = false}: FlexSuiteIntroIconCardsProps) {
  if (!cards?.length) return null

  const isTwoColumnLayout = cards.length === 2 || cards.length === 4
  const mediumColumnSpan = isTwoColumnLayout ? 6 : 4

  return (
    <Box className={baseStyles.cardGridFrame}>
      <Grid className={baseStyles.gridContent} columnGap="none" rowGap="none">
        {cards.map((item, index) => {
          const IconComponent = getPrimerIcon(item.fields.icon)
          return (
            /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
            <Grid.Column key={item.sys.id} span={{medium: mediumColumnSpan}} className="gridColumn">
              <Box
                className={clsx(baseStyles.cardGridItem, isTwoColumnLayout && baseStyles.cardGridItemTwoColumn)}
                padding={{narrow: 24, regular: 40}}
                paddingBlockStart={{regular: 80}}
                paddingBlockEnd={{regular: 80}}
                borderWidth="thin"
                borderColor="muted"
              >
                <Card href={item.fields.href} variant="minimal" fullWidth ctaText={item.fields.label}>
                  {IconComponent ? <Card.Icon icon={<IconComponent />} color="default" hasBackground /> : null}
                  {item.fields.eyebrow ? <Card.Label>{item.fields.eyebrow}</Card.Label> : null}
                  <Card.Heading as={index === 0 && promoteFirstHeading ? 'h2' : 'h3'} size="6">
                    {renderWithoutParagraphs(item.fields.heading)}
                    {item.fields.alt ? <span className="sr-only"> {item.fields.alt}</span> : null}
                  </Card.Heading>
                  <Card.Description>{renderWithoutParagraphs(item.fields.description)}</Card.Description>
                </Card>
              </Box>
            </Grid.Column>
          )
        })}
      </Grid>
    </Box>
  )
}
